import { render, staticRenderFns } from "./skillsList.vue?vue&type=template&id=1e57f52c&"
import script from "./skillsList.vue?vue&type=script&lang=js&"
export * from "./skillsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports